
import React, { useState, useEffect } from 'react';
import { PopupContent } from '@/types/popup-system';
import { Button } from '@/components/ui/button';

interface TerminalPopupProps {
  content: PopupContent;
  onDismiss: () => void;
  onAction?: (action: string) => void;
}

export const TerminalPopup = ({ content, onDismiss, onAction }: TerminalPopupProps) => {
  const [displayedMessage, setDisplayedMessage] = useState('');
  const [showCursor, setShowCursor] = useState(true);

  useEffect(() => {
    let index = 0;
    const timer = setInterval(() => {
      if (index < content.message.length) {
        setDisplayedMessage(content.message.slice(0, index + 1));
        index++;
      } else {
        clearInterval(timer);
      }
    }, 30);

    return () => clearInterval(timer);
  }, [content.message]);

  useEffect(() => {
    const cursorTimer = setInterval(() => {
      setShowCursor(prev => !prev);
    }, 500);

    return () => clearInterval(cursorTimer);
  }, []);

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80">
      <div className="bg-black border-2 border-green-500 max-w-2xl w-full mx-4 shadow-lg shadow-green-500/20">
        <div className="bg-green-500 text-black px-3 py-1 flex justify-between items-center">
          <span className="font-mono text-sm font-bold">{content.title}</span>
          {content.dismissible && (
            <button 
              onClick={onDismiss}
              className="hover:bg-green-600 px-2 py-0.5 text-xs"
            >
              [X]
            </button>
          )}
        </div>
        
        <div className="p-4 font-mono text-green-400 bg-black min-h-[200px]">
          <div className="mb-4">
            <span className="text-green-500">$</span> cat message.txt
          </div>
          
          <div className="border border-green-600 p-3 bg-black">
            <p className="leading-relaxed whitespace-pre-wrap">
              {displayedMessage}
              {showCursor && <span className="bg-green-400 text-black">█</span>}
            </p>
          </div>
          
          {content.actionButtons && content.actionButtons.length > 0 && (
            <div className="mt-4 flex gap-2">
              {content.actionButtons.map((button, index) => (
                <button
                  key={index}
                  onClick={() => onAction?.(button.action)}
                  className="border border-green-500 bg-black text-green-400 px-4 py-1 hover:bg-green-500 hover:text-black transition-colors font-mono text-sm"
                >
                  [{button.text}]
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
